import type { RelatedEntityModel } from '@models/relatedEntity'
import type { SubTaskType, TaskType } from '@functions/taskListItem'

export type TaskListItemModel = {
  id?: number,
  artwork_id?: number,
  assigned_points?: number,
  assignee_id?: number,
  cache_key?: number,
  checklist_template_id?: number,
  completed?: false,
  complexity?: 1 | 5 | 10,
  data?: {
    provider_id?: number,
    service_product_id?: number,
    task_type?: string,
  },
  dates?: {
    due: {
      date_time: string,
      integer: number,
    },
  },
  description?: string,
  due_date?: string,
  hidden?: false,
  notes?: string,
  notification_emails?: string[],
  parent_task_id?: number,
  priority?: string,
  related_entities_attributes?: RelatedEntityModel[],
  sort?: number,
  status_id?: number,
  task_list_id?: number,
  task_list_section_id?: number,
  task_list_template_item_id?: number,
  task_type?: SubTaskType | TaskType,
  template_page_ids?: number[],
  template_page_type?: string,
  ticketing_system?: 'freshdesk' | 'zendesk',
  ticketing_system_uid?: string,
  title?: string,
  type?: string,
  user_id?: number,
}

export type TaskListItemRequestOptions = {
  include_task_list_item_assignee?: string,
  include_task_list_item_attachments?: string,
  include_task_list_item_checklist_template?: string,
  include_task_list_item_parent_task?: string,
  include_task_list_item_parent_template_ids?: string,
  include_task_list_item_related_entities?: string,
  include_task_list_item_subject?: string,
  include_task_list_item_sub_tasks?: string,
  include_task_list_item_task_list?: string,
  include_task_list_item_template_task_list_item?: string,
}

const state = {
  id: undefined,
  artwork_id: undefined,
  assignee_id: undefined,
  completed: false,
  complexity: 1,
  data: {
    provider_id: undefined,
    service_product_id: undefined,
    task_type: '',
  },
  description: '',
  due_date: '',
  hidden: false,
  notes: '',
  notification_emails: [],
  parent_task_id: undefined,
  priority: 'default',
  related_entities_attributes: [],
  sort: undefined,
  status_id: undefined,
  task_list_id: undefined,
  task_list_section_id: undefined,
  task_list_template_item_id: undefined,
  task_type: undefined,
  template_page_ids: [],
  template_page_type: undefined,
  ticketing_system: 'freshdesk',
  ticketing_system_uid: undefined,
  title: '',
  user_id: undefined,
}

export const requiredFields = [
  { key: 'task_list_id' },
  { key: 'task_list_section_id' },
  { key: 'task_type' },
  { key: 'title' },
]

export default state
